module.exports = __webpack_public_path__ + "img/logo-light-icon.f65dc27e.png";